import { Ref } from "react";
import { ItemCardWithLocation } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCardWithLocation/ItemCardWithLocation";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { useItemInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemInfo";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";
import { ItemNoAndType } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import type { Location } from "@coworker/apprestructured/src/task-management/types/SalesLocation";
import styles from "./LocatedItemCreatorFragment.module.css";

export type LocatedItemCreatorFragmentConfigProps = {
  field: string;
  locationField: string;
};

type LocatedItemCreatorFragmentProps = {
  configProps: LocatedItemCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function LocatedItemCreatorFragment({
  configProps,
  commonProps,
}: LocatedItemCreatorFragmentProps) {
  const { task } = commonProps;
  const { field, locationField } = configProps;

  const itemData = getByPath(task, field) as ItemNoAndType | undefined;
  const locationData = getByPath(task, locationField) as Location | undefined;

  const { data: itemInfo, isLoading: isItemLoading } = useItemInfo(
    itemData?.no || ""
  );

  if (isLoading(task) || isItemLoading) {
    return <LoadingCreatorFragment />;
  }

  if (!itemInfo) {
    return null;
  }

  const hfbNo = locationData?.slid || locationData?.custom || itemInfo.hfbNo;

  return (
    <div className={styles["container"]}>
      <ItemCardWithLocation item={itemInfo} location={hfbNo} />
    </div>
  );
}

export default LocatedItemCreatorFragment;
